import { Note as NoteNode } from "@acto/gql/graphql";
import dayjs, { Dayjs } from "dayjs";

export default class Note {
  constructor(
    public readonly id: string,
    public readonly clientId: string,
    public readonly content: string,
    public readonly createdAt: Dayjs,
    public readonly updatedAt: Dayjs,
    public readonly meetingId?: string | null,
    public readonly title?: string | null,
    public readonly summary?: string | null,
    public readonly openTodosCount = 0,
  ) {}

  static fromGraphql(data: NoteNode): Note {
    // If already transformed, return as-is
    if (data instanceof Note) {
      return data;
    }

    return new Note(
      data.id,
      data.clientId,
      data.content,
      dayjs.isDayjs(data.createdAt) ? data.createdAt : dayjs(data.createdAt),
      dayjs.isDayjs(data.updatedAt) ? data.updatedAt : dayjs(data.updatedAt),
      data.meetingId,
      data.title,
      data.summary,
      data.openTodosCount ?? 0,
    );
  }
}
